import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'
import { GET_VISITORS_QUERY_KEY } from '~/features/hooks/useGetVisitors'
import { toast } from 'sonner'

export const useDeleteVisitor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => {
      await supabaseApi.from('visitors').delete().eq('id', id)
    },
    onSuccess: () => {
      toast.success('Visitor deleted successfully')
      queryClient.invalidateQueries({ queryKey: [GET_VISITORS_QUERY_KEY] })
    },
    onError: (error) => {
      toast.error('Visitor could not be deleted', { description: error.message })
    },
  })
}
